module.exports = __webpack_public_path__ + "img/b1.7999f81b.jpg";